<div class="container-fluid d-flex justify-content-center">
    <div class="custom-container">
        <p-scrollPanel *ngIf="this.transferList.length > 0" [style]="{width: '100%'}">
            <div style="width: 95%;margin: 20px;" class="card table-responsive">
                <p-table responsiveLayout="stack" (onPage)="onTransferPageChange($event)" [value]="transferList"
                    styleClass="p-datatable-gridlines" [loading]="loading" [paginator]="true" [rows]="10"
                    [(first)]="transferPageIndex" [showCurrentPageReport]="true" dataKey="RowNum"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10,20,50]">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th>
                            <!-- <input type="checkbox" (change)="transferCheckAllChange($event)" style="margin-left: 2px;" class="form-check-input" [checked]="transferCheckAll"> -->
                            Confirm
                          </th>
                          <th>Id</th>
                          <th>Service</th>
                          <th>Request Id</th>
                          <th>Service Type</th>
                          <th>Pickup Location</th>
                          <th>DropOff Location</th> 
                          <th>Total Pax</th>
                          <th>Supplier Name</th> 
                          <th>Guest Name</th>
                          <th>Status</th>
                          <th>Remarks</th>
                          <th>Confirmation No</th>
                          <th>Supplier Remarks</th>
                          <!-- <th>
                            <p-inputSwitch [(ngModel)]="transferSwitchAll" (onChange)="transferSwitchAllChange($event)"></p-inputSwitch>
                          </th> -->
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-product let-columns="columns">
                        <tr style="max-height: 30px;">
                          <td>
                            <input type="checkbox" (change)="transferCheckChange($event, rowIndex)" style="margin-left: 2px;" [disabled]="product.assign_status == 'Confirmed'" class="form-check-input" [checked]="product.isChecked">
                          </td>
                          <td>{{product.assignmentid}}</td>
                          <td>{{product.ServiceType}}</td>
                          <td>{{product.requestid}}</td>
                          <td>{{product.assigntype}}</td>
                          <td>{{product.pickupName}}</td>
                          <td>{{product.dropoffName}}</td>
                          <td>{{product.pax}}</td>
                          <td>{{product.partyname}}</td>
                          <td>{{product.Guestname}}</td>
                          <td>{{product.assign_status}}</td>
                          <td>{{product.remarks}}</td>
                          <td>
                            <p-cellEditor *ngIf="product.isChecked">
                              <ng-template pTemplate="input">
                                <input pInputText type="text"
                                  [(ngModel)]="product.transferconfno">
                              </ng-template>
                              <ng-template pTemplate="output">
                                <input pOutputText type="text"
                                  [(ngModel)]="product.transferconfno">
                              </ng-template>
                            </p-cellEditor>
                            <span *ngIf="!product.isChecked">{{product.transferconfno}}</span>
                          </td>
                          <td>
                            <p-cellEditor *ngIf="product.isChecked">
                              <ng-template pTemplate="input">
                                <input pInputText type="text"
                                  [(ngModel)]="product.supplier_remarks">
                              </ng-template>
                              <ng-template pTemplate="output">
                                <input pOutputText type="text"
                                  [(ngModel)]="product.supplier_remarks">
                              </ng-template>
                            </p-cellEditor>
                            <span *ngIf="!product.isChecked">{{product.supplier_remarks}}</span>
                          </td>
                          <!-- <td>
                            <p-inputSwitch [(ngModel)]="product.isSwitched" (onChange)="transferSwitchChange($event, rowIndex)"></p-inputSwitch>
                          </td> -->
                        </tr>
                      </ng-template>
                </p-table>
            </div>
        </p-scrollPanel>

        <p-scrollPanel *ngIf="this.excursionList.length > 0" [style]="{width: '100%', height: '40vh'}">
          <div style="width: 95%;margin: 20px;" class="card table-responsive">
            <p-table responsiveLayout="stack" (onPage)="onExcursionPageChange($event)" [value]="excursionList"
                styleClass="p-datatable-gridlines" [loading]="loading" [paginator]="true" [rows]="10"
                [(first)]="excursionPageIndex" [showCurrentPageReport]="true" dataKey="RowNum"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10,20,50]">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th>Confirm</th>
                    <th>Request Id</th>
                    <th>Service Type</th>
                    <th>Service Date</th>
                    <th>Pax</th>
                    <th>Start Time</th>
                    <th>End Time</th> 
                    <th>Pickup Location</th>
                    <th>Dropoff Location</th>
                    <th>Status</th>
                    <th>Remarks</th>
                    <th>Confirmation No</th>
                    <th>Supplier Remarks</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-product let-columns="columns">
                  <tr style="max-height: 30px;">
                    <td>
                      <input type="checkbox" style="margin-left: 2px;" [disabled]="product.serviceStatus == 3" class="form-check-input" [checked]="product.isChecked">
                    </td>
                    <td>{{product.requestid}}</td>
                    <td>{{product.sm_name}}</td>
                    <td>{{product.excdate}}</td>
                    <td>{{product.adults}} Adults {{product.child}} Child</td>
                    <td>{{product.starttime}}</td>
                    <td>{{product.endtime}}</td>
                    <td>{{product.pickup}}</td>
                    <td>{{product.drop_off}}</td>
                    <td *ngIf="product.serviceStatus == 1">Pending</td>
                    <td *ngIf="product.serviceStatus == 2">Assigned</td>
                    <td *ngIf="product.serviceStatus == 3">Confirmed</td>
                    <td *ngIf="product.serviceStatus == 5">Rejected</td>
                    <td>{{product.ExcSupComment}}</td>
                    <td>
                      <p-cellEditor *ngIf="product.isChecked">
                        <ng-template pTemplate="input">
                          <input pInputText type="text"
                            [(ngModel)]="product.toursconfno">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input pOutputText type="text"
                            [(ngModel)]="product.toursconfno">
                        </ng-template>
                      </p-cellEditor>
                      <span *ngIf="!product.isChecked">{{product.toursconfno}}</span>
                    </td>
                    <td>
                      <p-cellEditor *ngIf="product.isChecked">
                        <ng-template pTemplate="input">
                          <input pInputText type="text"
                            [(ngModel)]="product.supplier_remarks">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input pOutputText type="text"
                            [(ngModel)]="product.supplier_remarks">
                        </ng-template>
                      </p-cellEditor>
                      <span *ngIf="!product.isChecked">{{product.supplier_remarks}}</span>
                    </td>
                  </tr>
                </ng-template>
            </p-table>
          </div>
        </p-scrollPanel>

        <div *ngIf="(transferList.length > 0 || excursionList.length > 0) && !this.confirmbookingdisable" class="row">
            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="col-12">
                  <label class="form-label" for="name"><br></label>
              </div>
              <div class="col-12">
                <button type="button" style="float: left;" (click)="ConfirmBooking()"
                  class="primary-default-btn">Confirm Booking</button>
              </div>
            </div>
            <!-- <div class="col-lg-1 col-md-2 col-sm-3 col-xs-12">
                <div class="col-12">
                    <label class="form-label" for="name"><br></label>
                </div>
                <div class="col-12">
                  <button type="button" style="float: left;"
                    class="primary-default-btn">Reject</button>
                </div>
            </div> -->
        </div>
    </div>
</div>